<template>
  <div>
    <div class="section pt-0">
      <div class="container">
        <h1 class="title">
          Les influences musicales à travers le monde
        </h1>
        <v-chord
          :songs="songs"
          :song-list="false"
          :min-date="1900"
          :max-date="2000"
          :help="false"
          :tuto="true" 
        />
      </div>
    </div>
  </div>
</template>

<script>

import Chord from "@/components/Chord";

export default {
	components: {
		"v-chord": Chord
	},
	computed: {
		songs () {
			return Object.values(this.$store.state.songs);
		}
	}
};
</script>
